module.exports = __webpack_public_path__ + "static/img/vip-new-button.bc8236f6.png";